import { Capacitor } from '@capacitor/core';

export const isStandaloneApplication = () =>
    window.matchMedia('(display-mode: standalone)').matches || // chrome, android, etc.
    (window.navigator as any).standalone; // safari only

/** Running inside the native (Capacitor) Android/iOS app. */
export const isNativeApp = () => Capacitor.isNativePlatform();

export const isiOS = () => {
    return (
        ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
            navigator.platform
        ) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    );
};

export const getiOSVersion = () => {
    const agent = window.navigator.userAgent;
    const start = agent.indexOf('OS ');
    if ((agent.indexOf('iPhone') > -1 || agent.indexOf('iPad') > -1) && start > -1) {
        return window.Number(agent.substr(start + 3, 3).replace('_', '.'));
    }
    return 0;
};

export const supportsFullscreen = () => !isNativeApp();

export const supportsDeviceChangeEvent = () =>
    navigator.mediaDevices != null &&
    navigator.mediaDevices.addEventListener != null &&
    navigator.mediaDevices.removeEventListener != null;

export const supportsMediaDevices = () =>
    navigator.mediaDevices != null && navigator.mediaDevices.enumerateDevices != null;

export const isSupportedDevice = () =>
    isNativeApp() ||
    // getiOSVersion() returns 0 when the version can't be read from the UA. This is the
    // normal case on iPadOS 13+, where Safari identifies as a desktop Mac (no "iPad" token)
    // yet fully supports getUserMedia. Only reject when we positively detect an old iOS (<= 12).
    (supportsMediaDevices() && (!isiOS() || getiOSVersion() === 0 || getiOSVersion() > 12));
